/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';

/**
 * Access Denied provides a presentation component that generates a warning
 * for when a user isn't allowed to access content.
 */
export default class AccessDenied extends Component {}
